import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../fragments/__generated__/PageInfo.generated';
import { SocialPostFragmentDoc } from '../../fragments/__generated__/SocialPost.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SocialPostsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  createdLt?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  createdGt?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  orderBy: Array<Types.SocialPostOrder> | Types.SocialPostOrder;
}>;


export type SocialPostsQuery = { socialPosts: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, created: any, externalLink: string, link: string, name: string, sortOrder: number, type: string, description: string, status: string, username: string, images: Array<{ id: string, url: string, thumbnailUrl: string | null }> } }> } };


export const SocialPostsDocument = gql`
    query SocialPosts($first: Int, $last: Int, $after: String, $createdLt: DateTime, $createdGt: DateTime, $orderBy: [SocialPostOrder!]!) {
  socialPosts(
    first: $first
    last: $last
    after: $after
    filters: {created: {gt: $createdGt, lt: $createdLt}}
    ordering: $orderBy
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        ...SocialPostFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SocialPostFragmentDoc}`;

/**
 * __useSocialPostsQuery__
 *
 * To run a query within a React component, call `useSocialPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialPostsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      createdLt: // value for 'createdLt'
 *      createdGt: // value for 'createdGt'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSocialPostsQuery(baseOptions: Apollo.QueryHookOptions<SocialPostsQuery, SocialPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialPostsQuery, SocialPostsQueryVariables>(SocialPostsDocument, options);
      }
export function useSocialPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialPostsQuery, SocialPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialPostsQuery, SocialPostsQueryVariables>(SocialPostsDocument, options);
        }
export type SocialPostsQueryHookResult = ReturnType<typeof useSocialPostsQuery>;
export type SocialPostsLazyQueryHookResult = ReturnType<typeof useSocialPostsLazyQuery>;
export type SocialPostsQueryResult = Apollo.QueryResult<SocialPostsQuery, SocialPostsQueryVariables>;
export function refetchSocialPostsQuery(variables: SocialPostsQueryVariables) {
      return { query: SocialPostsDocument, variables: variables }
    }